<template>
  <div>
    <div class='jumbotron jumbotron-fluid splash'>
      <div>
        <div class='title'>
          <div class="title-line-1">LogoUp 3D 为 STEAM 教育而生</div>
          <div class="title-line-2" style='font-weight:400;margin-top:0.3em'>配套面向不同层次的教程体系</div>
          <div class="title-line-1" style='font-weight:400;'>快速入门 >> 进阶拓展 >> 高级开发</div>
          <div style='margin-top:3em;margin-bottom:0.8em;text-align:right; text-shadow:none'>
            单击下方观看面向教师和工程师的视频教程<br />
            <!-- 《LogoUp 程序式三维建模软件 从入门到精通》免费教程 -->
             《LogoUp 程序式三维建模软件 从入门到精通》教程
          </div>
          <div>
            <a class='download' href='https://wx84eef5a05cc1729b.h5.xiaoe-tech.com' target='_blank'>
              <img src='/static/studycenter.png' />
              学习中心
            </a>
            <!-- <a class='download' href='http://search.bilibili.com/all?keyword=LogoUp' target='_blank'>
              <img src='/static/bilibili.png' />
              bilibili.com
            </a>
            <a class='download' href='http://list.youku.com/albumlist/show/id_49756719' target='_blank'>
              <img src='/static/youku.png' />
              youku.com
            </a> -->
          </div>
          <div style='text-shadow:none;margin-top:1em'>更多付费教程请微信登陆⌊学习中心⌉</div>
        </div>
      </div>
    </div>
    <div class='container'>
      <div class='content-section'>
        <h3>
          从入门到精通
          <!-- <div>面向教师、工程师和设计师的 8 课时免费视频实操教程</div> -->
          <div>面向教师、工程师和设计师的 8 课时视频实操教程</div>
        </h3>
        <div class="row align-items-center justify-content-center">
          <div class='col-6 col-sm-4 col-md-3 col-lg-2 ml-auto mr-auto' style="text-align:center; margin-top:1em;">
            <img src='/static/bookshelf.png' />
          </div>
          <div class="col-12 col-sm-8 col-md-9 col-lg-4 ml-auto mr-auto intro" style="margin-top:1em;">
            <!-- <h4>免费视频使用教程</h4> -->
             <h4>视频使用教程</h4>
            <div>
              8 课时（每课 45 分钟）视频使用教程<br />
              <!-- LogoUp 配套免费教程 -->
               LogoUp 配套教程
            </div>
          </div>
          <div class="col-6 col-sm-4 col-md-3 col-lg-2 ml-auto mr-auto" style="text-align:center; margin-top:1em;">
            <img src='/static/female.png' />
          </div>
          <div class="col-12 col-sm-8 col-md-9 col-lg-4 ml-auto mr-auto intro" style="margin-top:1em;">
            <h4>面向教师、工程师和设计师</h4>
            <div>
              边看视频边实操，学习使用 LogoUp 语言<br />
              零基础快速上手，深入学习编程和造型理念
            </div>
          </div>
        </div>
        <div class='text'>
          <h4 style='margin-top:2em'>课程内容和安排</h4>
          <table cellpadding='0' cellspacing='0' style='margin-top:2em;width:100%'>
            <tr>
              <th style='width:3em'></th>
              <th style='width:6em'>课程名称</th>
              <th style='width:7em'>理论知识</th>
              <th>LogoUp 语法</th>
              <th>软件操作</th>
            </tr>
            <tr>
              <th>第一课</th>
              <td>快速入门</td>
              <td>平面游标移动</td>
              <td>DRAW / GO / TURN / DONE</td>
              <td>新建、保存、打开、积木基本操作、鼠标视图操作</td>
            </tr>
            <tr style='background:#f4f4f4'>
              <th>第二课</th>
              <td>进阶二维绘图</td>
              <td>内环和外环</td>
              <td>HOME / CLEAR / WIDTH / FILL</td>
              <td>绘制复杂的形状、草图视图</td>
            </tr>
            <tr>
              <th>第三课</th>
              <td>三维绘图</td>
              <td>空间姿态</td>
              <td>YAW / PITCH / ROLL / BODY / UP</td>
              <td>标准视图操作、隐藏显示视图元素</td>
            </tr>
            <tr style='background:#f4f4f4'>
              <th>第四课</th>
              <td>进阶三维设计</td>
              <td>回转面</td>
              <td>SCALE / JUMP / LINK / RESET / COLOR</td>
              <td>回转面生成</td>
            </tr>
            <tr>
              <th>第五课</th>
              <td>重复结构绘制</td>
              <td>循环和重复</td>
              <td>REPEAT / VAR</td>
              <td>重复结构积木设计、循环嵌套、缩进</td>
            </tr>
            <tr style='background:#f4f4f4'>
              <th>第六课</th>
              <td>过程与函数</td>
              <td>过程与函数、标准库</td>
              <td>FUNC / REPEAT UNTIL / WHEN</td>
              <td>自动排版、命名规则</td>
            </tr>
            <tr>
              <th>第七课</th>
              <td>绝对坐标绘图</td>
              <td>三维坐标系</td>
              <td>GOTO / TURNTO / YAWTO / PITCHTO / ROLLTO</td>
              <td>角度编辑框、吸附操作、注释、三角函数</td>
            </tr>
            <tr style='background:#f4f4f4'>
              <th>第八课</th>
              <td>形体的组合</td>
              <td>布尔运算</td>
              <td>ERASE / SUBTRACT</td>
              <td>3D 打印、输出、打印设置、模型统计</td>
            </tr>
          </table>
        </div>
      </div>
      <div class='content-section' style="margin-top: 2em">
        <h3>
          尼奥博士的实验室
          <div>面向青少年的商业 STEAM 课程培训体系</div>
        </h3>
        <img src='/static/course-book.jpg' style='float:right;border-radius:16px;margin-right:2em;' width='93%' />
        <div class='slide' style='margin-left:20%;margin-top:4em;color:#59a3a6;font-weight:bold'>
          &nbsp;<br />
          <span style='font-size:24px'>哥哥，你怎么又把实验室炸了？</span><br />
          <span style='font-size:18px'>让我们来一起重建实验室吧！</span>
        </div>
        <div class='text'>
          《尼奥博士的实验室》讲述的是八岁女孩儿莉莉和他的科学家哥哥尼奥博士在家中发生的各种趣事。
          课程体系分为 12 个课时，以莉莉和尼奥博士之间发生的有趣事件贯穿始终，
          将课程任务和故事融合在一起，通过课程任务，讲授基于 LogoUp 语言的三维设计、程序设计和 3D 打印制作的知识和技能，
          培养学生的<b>独立思考能力</b>、<b>创新创造兴趣</b>、<b>项目管理能力</b>和<b>合作交流能力</b>。
        </div>
        <div class='row align-items-center justify-content-md-center'>
          <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="text-align:center;margin-top:1em;">
            <img src='/static/bookshelf.png' />
          </div>
          <div class="col-12 col-sm-9 col-md-9 col-lg-4 intro">
            <h4>适合于课堂的教学体系</h4>
            <div>
              12 课时，每节课 40 分钟<br />
              面向青少年编程、三维和创造性学习<br />
              零基础冷启动，10 岁以上即可
            </div>
          </div>
          <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="text-align:center;margin-top:1em;">
            <img src='/static/vessel.png' />
          </div>
          <div class="col-12 col-sm-9 col-md-9 col-lg-4 intro">
            <h4>目标驱动的 STEAM 教育理念</h4>
            <div>
              每节课以故事引入给出目标<br />
              以目标驱动实践技能和理论知识学习<br />
              巩固传统课程、突出实战能力
            </div>
          </div>
          <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="text-align:center;margin-top:1em;">
            <img src='/static/check.png' />
          </div>
          <div class="col-12 col-sm-9 col-md-9 col-lg-4 intro">
            <h4>培养多方面能力素质</h4>
            <div>
              独立思考解决问题的能力<br />
              不断学习新技能创新创造的能力<br />
              管理项目进展与朋友合作的能力
            </div>
          </div>
          <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="text-align:center;margin-top:1em;">
            <img src='/static/programming.png' />
          </div>
          <div class="col-12 col-sm-9 col-md-9 col-lg-4 intro">
            <h4>紧扣设计、3D 打印和编程</h4>
            <div>
              学习基本的程序设计能力<br />
              掌握三维设计技能，可以设计出有用作品<br />
              能够通过 3D 打印制造出交付物
            </div>
          </div>
        </div>
      </div>
      <div class='content-section' style='margin-top: 8em'>&nbsp;<br />&nbsp;<br /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'course',
  data() {
    return { };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .splash {
    background-color: #374e5e;
    background-image: url(/static/course-bg.jpg);
    background-repeat: no-repeat;
    width: 100%;
    background-position: center;
    background-size: fill;
    transition: background 1s;
  }
  .splash .ui-img {
    margin-left: -2em;
    display: inline-block;
  }
  .splash .title {
    vertical-align: top;
    color: white;
    text-shadow: 2px 2px 3px #0078d7;
    font-weight: 100;
    text-align: right;
    padding-right: 4%;
  }
  .splash .download {
    padding: 0.5em 1em;
    display: inline-block;
    background: white;
    text-shadow: none;
    box-shadow: 2px 2px 3px 3px #004847;
    border-radius: 8px;
    cursor: pointer;
    width: 100px;
    font-size: 12px;
    text-align: center;
    padding: 1em;
    margin-left: 1em;
  }
  .splash .download:hover {
    background: #f0f0f0;
  }
  .slide {
    background: #f0f0f0;
    padding: 2em 3em;
    margin-top: 2em;
    margin-bottom: 2em;
    line-height: 32px;
    border: solid 1px #ddd;
    border-radius: 16px;
    font-size: 18px;
    font-weight: 100;
  }
  .slide b {
    color: #0078d7;
  }
  table th {
    padding: 0.8em 1em;
    border-bottom: solid 1px #ccc;
    color: #f84;
    font-size: 18px;
    text-align: left;
  }
  table td {
    text-align: left;
    font-size: 14px;
  }
  @media (max-width: 576px) {
    .intro {
      text-align: center;
    }
    .intro h4 {
      margin-top:0.5em;
    }
    .title-line-1 {
      font-size: 4.8vw;
    }
    .title-line-2 {
      font-size: 7vw;
    }
  }
  @media (min-width: 576px) {
    .intro h4 {
      margin-top:1.0em;
    }
    .title-line-1 {
      font-size: 28px;
    }
    .title-line-2 {
      font-size: 42px;
    }
  }
  @media (min-width: 760px) {
    table td {
      padding: 0.8em 1em;
    }
  }
  @media (max-width: 760px) {
    /* Force table to not be like tables anymore */
    table, thead, tbody, th, td, tr {
      display: block;
    }
    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr { border: 1px solid #ccc; }

    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #eee;
      position: relative;
      padding-left: 50%;
      font-size: 0.7rem;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 6px;
      left: 6px;
      width: 45%;
      padding-right: 10px;
      white-space: nowrap;
    }

    /*
    Label the data
    */
    td:nth-of-type(1):before { content: "课程名称："; }
    td:nth-of-type(2):before { content: "理论知识："; }
    td:nth-of-type(3):before { content: "LogoUp 语法："; }
    td:nth-of-type(4):before { content: "软件操作："; }
    table tr:first-child {
      display: none;
    }
    table > tr > th {
      padding: 0.8em 1em;
      border-bottom: solid 1px #ccc;
      color: #f84;
      font-size: 18px;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/course.vue